import * as React from "react";
import type { SVGProps } from "react";
const SvgX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M19 5 5 19m14 0L5 5"
    />
  </svg>
);
export default SvgX01;
